import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import StarIcon from '../../svg/icons/star.svg';
import starMap from '../../constants/starMap';

import './Star.scss';
import { sanitizeString } from '../../utils/sanitizeString';

const getFill = (type) => {
  // safari requires page location
  // https://stackoverflow.com/questions/11303740/svg-linear-gradient-doesnt-work-in-safari
  if (type === 'half') {
    return `url(${window.location.href}#star-half`;
  }

  return undefined;
};

const isHalfWrittenToDoc = () => document.querySelector('#star-half');

const linearGradient = '<svg width="0" height="0" viewBox="0 0 0 0" xmlns="http://www.w3.org/2000/svg"><defs>'
  + '<linearGradient id="star-half"><stop offset="50%" stop-color="#FF462D"></stop><stop offset="50%" stop-color="#EAEAEA"></stop></linearGradient>'
  + '</defs></svg>';

const Star = ({ type, className }) => {
  useEffect(() => {
    if (!isHalfWrittenToDoc()) {
      const div = document.createElement('div');
      div.setAttribute('class', 'zero-dimensions');
      div.innerHTML = sanitizeString(linearGradient);
      document.querySelector('body').append(div);
    }
  }, []);

  const fill = getFill(type);

  return (
    <div
      className={cx('Star', {
        [`Star--${type}`]: true,
        [className]: className !== '',
      })}
      style={fill ? { fill } : {}}
    >
      <StarIcon />
    </div>
  );
};

Star.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf([
    starMap.EMPTY,
    starMap.FULL,
    starMap.HALF,
  ]),
};

Star.defaultProps = {
  className: '',
  type: starMap.FULL,
};

export default Star;
